import {
  LayoutDashboard,
  Briefcase,
  Building2,
  Package,
  FolderKanban,
  Users,
  UserCog,
  ShieldCheck,
  ShieldHalf,
  CalendarDays,
  CheckSquare,
  Zap,
  FileText,
  Lightbulb,
  Scale,
  Wallet,
  Receipt,
  Flag,
  KeyRound,
  Paperclip,
  ClipboardList,
  ListTree,
  BarChart2,
  PieChart,
  TrendingUp,
  Bell,
  Mail,
  MessageSquare,
  Settings,
  Database,
  Globe,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Star,
  Bookmark,
  Tag,
  Filter,
  Search,
  Download,
  Upload,
  Share2,
  Link2,
  ExternalLink,
  Home,
  Map,
  Clock,
  Calendar,
  Activity,
  Layers,
  Grid,
  List,
  Table,
  ChevronRight,
  ArrowRight,
  Plus,
  Edit,
  Trash2,
  RefreshCw,
  AlertCircle,
  Calculator,
  History,
  Bug,
  ClipboardCheck,
  type LucideIcon,
} from "lucide-react";

export const iconMap: Record<string, LucideIcon> = {
  LayoutDashboard,
  Briefcase,
  Building2,
  Package,
  FolderKanban,
  Users,
  UserCog,
  ShieldCheck,
  ShieldHalf,
  CalendarDays,
  CheckSquare,
  Zap,
  FileText,
  Lightbulb,
  Scale,
  Wallet,
  Receipt,
  Flag,
  KeyRound,
  Paperclip,
  ClipboardList,
  ListTree,
  BarChart2,
  PieChart,
  TrendingUp,
  Bell,
  Mail,
  MessageSquare,
  Settings,
  Database,
  Globe,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  Star,
  Bookmark,
  Tag,
  Filter,
  Search,
  Download,
  Upload,
  Share2,
  Link2,
  ExternalLink,
  Home,
  Map,
  Clock,
  Calendar,
  Activity,
  Layers,
  Grid,
  List,
  Table,
  ChevronRight,
  ArrowRight,
  Plus,
  Edit,
  Trash2,
  RefreshCw,
  AlertCircle,
  Calculator,
  History,
  Bug,
  ClipboardCheck,
};

export const ICON_GROUPS: { label: string; icons: string[] }[] = [
  {
    label: "Navigation",
    icons: [
      "LayoutDashboard",
      "Home",
      "Map",
      "Layers",
      "Grid",
      "List",
      "Table",
      "ChevronRight",
      "ArrowRight",
      "ExternalLink",
    ],
  },
  {
    label: "Business",
    icons: [
      "Briefcase",
      "Building2",
      "Package",
      "FolderKanban",
      "Users",
      "UserCog",
      "ShieldCheck",
      "ShieldHalf",
      "ClipboardList",
      "ListTree",
      "Activity",
    ],
  },
  {
    label: "Finance",
    icons: [
      "Wallet",
      "Receipt",
      "BarChart2",
      "PieChart",
      "TrendingUp",
      "Tag",
      "Flag",
      "Star",
      "Bookmark",
      "KeyRound",
    ],
  },
  {
    label: "Communication",
    icons: [
      "Bell",
      "Mail",
      "MessageSquare",
      "CalendarDays",
      "Calendar",
      "Clock",
      "Share2",
      "Link2",
      "Globe",
      "Lightbulb",
    ],
  },
  {
    label: "Status",
    icons: [
      "CheckSquare",
      "Zap",
      "Scale",
      "AlertCircle",
      "Lock",
      "Unlock",
      "Eye",
      "EyeOff",
      "RefreshCw",
      "Settings",
    ],
  },
  {
    label: "Files",
    icons: [
      "FileText",
      "Paperclip",
      "Database",
      "Filter",
      "Search",
      "Download",
      "Upload",
      "Plus",
      "Edit",
      "Trash2",
    ],
  },
];

export function getIcon(name: string): LucideIcon {
  return iconMap[name] ?? LayoutDashboard;
}
